import { DataModelBuilder, SerializationContext, SerializedData } from '../../models/dto/data-model.js';
import { cloneList, isSameList } from '../../models/dto/data-model-utils.js';
import { fromEnumAsString, toEnumFromString } from '../../serialization/enum-utils.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';
import { VoucherAttachmentType } from './voucher-attachment-type.js';

export class VoucherAttachmentComponent extends Component {
  static readonly TYPE_ID: string = '79e6b51a6d9d4d3cb7b52234323ee3ff';

  constructor(
    public readonly attachments: VoucherAttachmentType[],
  ) {
    super();
  }

  get $typeId(): string {
    return VoucherAttachmentComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return true;
  }

  static fromMap(context: SerializationContext, map: SerializedData): VoucherAttachmentComponent {
    return new VoucherAttachmentComponent(
        MapUtils.getList<VoucherAttachmentType>(
            map,
            'attachments',
            (e) => toEnumFromString(e as string, VoucherAttachmentType)
        ),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      attachments: this.attachments.map((e) => fromEnumAsString(e)),
    };
  }

  clone(): this {
    return new VoucherAttachmentComponent(
        cloneList(this.attachments),
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameList(other.attachments, this.attachments);
  }
}

export class VoucherAttachmentComponentBuilder extends DataModelBuilder<VoucherAttachmentComponent> {
  build(context: SerializationContext, map: SerializedData): VoucherAttachmentComponent {
    return VoucherAttachmentComponent.fromMap(context, map);
  }
}
